import { useHookstate } from '@hookstate/core';
import { PassThrough, TopModel, TopModelMerge } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
import {
  NewsLetterBoxForm,
  NewsLetterSubmitError,
  NewsLetterSubmitSuccess,
} from './components';
import {
  newsLetterSubmitErrorState,
  newsLetterSubmitSuccessState,
  resetNewsLetterStates,
} from './state';
import { NewsLetterBoxFormContentContainer } from './components/form/components/content/components';
import { NewsLetterBoxEmailContainer } from './components/form/components/content/components/email/components';
import { NewsLetterBoxFirstNameLastNameContainer } from './components/form/components/content/components/firstNameLastName/components';
import { NewsLetterBoxInputContainer, NewsLetterBoxInputContent } from './components/input/components';
import { NewsLetterBoxFormSubmitButtonWrapper } from './components/form/components/submitButton/components';

export type NewsLetterBoxContentTopModels = Partial<{
  newsLetterFormWrapper: JSX.Element | null,
  titleContainer: JSX.Element | null,
  titleContent: JSX.Element | null,
  subTitleContainer: JSX.Element | null,
  subTitleContent: JSX.Element | null,
  formContentContainer: JSX.Element | null,
  emailContainer: JSX.Element | null,
  firstNameLastNameContainer: JSX.Element | null,
  formSubmitButtonWrapper: JSX.Element | null,
  inputContainer: JSX.Element | null,
  'inputContainer-firstName': JSX.Element | null,
  'inputContainer-lastName': JSX.Element | null,
  'inputContainer-email': JSX.Element | null,
  inputContent: JSX.Element | null,
  'inputContent-firstName': JSX.Element | null,
  'inputContent-lastName': JSX.Element | null,
  'inputContent-email': JSX.Element | null,
}>

export const NewsLetterBoxContent = (props: {
  topModels: NewsLetterBoxContentTopModels,
}) => {
  const {
    topModels,
  } = props;
  const topModelsWithDefault = React.useMemo(() => ({
    newsLetterFormWrapper: topModels.newsLetterFormWrapper ?? (<TopModel name="newsLetterFormWrapper">{PassThrough}</TopModel>),
    titleContainer: topModels.titleContainer ?? null,
    titleContent: topModels.titleContent ?? null,
    subTitleContainer: topModels.subTitleContainer ?? null,
    subTitleContent: topModels.subTitleContent ?? null,
    formContentContainer: topModels.formContentContainer ?? (<TopModel name="subTitleContent">{NewsLetterBoxFormContentContainer}</TopModel>),
    emailContainer: topModels.emailContainer ?? (<TopModel name="emailContainer">{NewsLetterBoxEmailContainer}</TopModel>),
    firstNameLastNameContainer: topModels.firstNameLastNameContainer ?? (<TopModel name="firstNameLastNameContainer">{NewsLetterBoxFirstNameLastNameContainer}</TopModel>),
    inputContent: topModels.inputContent ?? (<TopModel name="inputContent">{NewsLetterBoxInputContent}</TopModel>),
    formSubmitButtonWrapper: topModels.formSubmitButtonWrapper ?? (<TopModel name="formSubmitButtonWrapper">{NewsLetterBoxFormSubmitButtonWrapper}</TopModel>),
    inputContainer: topModels.inputContainer ?? (<TopModel name="inputContainer">{NewsLetterBoxInputContainer}</TopModel>),
    'inputContainer-firstName': topModels['inputContainer-firstName'] ?? null,
    'inputContainer-lastName': topModels['inputContainer-lastName'] ?? null,
    'inputContainer-email': topModels['inputContainer-email'] ?? null,
  }), [
    topModels.titleContainer,
    topModels.titleContent,
    topModels.subTitleContainer,
    topModels.subTitleContent,
    topModels.formContentContainer,
    topModels.emailContainer,
    topModels.firstNameLastNameContainer,
    topModels.inputContent,
    topModels.formSubmitButtonWrapper,
    topModels.inputContainer,
    topModels['inputContainer-firstName'],
    topModels['inputContainer-lastName'],
    topModels['inputContainer-email'],
  ]);
  React.useEffect(
    () => {
      resetNewsLetterStates();
    },
    [],
  );
  const submitSuccess = useHookstate(newsLetterSubmitSuccessState);
  const submitError = useHookstate(newsLetterSubmitErrorState);
  if (submitSuccess.get() === true) {
    return (
      <NewsLetterSubmitSuccess />
    );
  }
  if (submitError.get() === true) {
    return (
      <NewsLetterSubmitError />
    );
  }
  return (
    <TopModelMerge
      topModels={topModelsWithDefault}
    >
      <NewsLetterBoxForm />
    </TopModelMerge>
  );
};
